import { useParams } from 'react-router-dom';
import { useGetOrganizations } from '@/reactQuery/get';
import { Organization } from '@/types';

const useOrganization = () => {
  const { organization_id: organizationId } = useParams();
  const { data: { items: organizations } = {}, isLoading } = useGetOrganizations();

  const organization = organizations?.find(({ _id }: Organization) => _id === organizationId);

  return { organization, isLoading };
};

export default useOrganization;
